import { fromEvent, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
export var LegacyEventsEnum;
(function (LegacyEventsEnum) {
    // sign in messages
    LegacyEventsEnum["UserSignIn"] = "sendUserSignInMessage";
    LegacyEventsEnum["UserSignOut"] = "sendUserSignOutMessage";
    // sign in dialogs
    LegacyEventsEnum["ShowSignInDialog"] = "popUnderSignInModal";
    LegacyEventsEnum["ShowSignOutDialog"] = "popUnderSignOutModal";
    LegacyEventsEnum["ShowSignUpDialog"] = "popUnderSignUpModal";
    // profile messages
    LegacyEventsEnum["ShowUpdateProfileDialogSuccess"] = "popUnderUpdateProfileModal_CompleteProfile";
    LegacyEventsEnum["ProfileUpdated"] = "sendUserProfileUpdated";
    LegacyEventsEnum["ProfileDeleted"] = "sendUserProfileDeleted";
    // profile dialog
    LegacyEventsEnum["ShowUserMyAccountDialog"] = "popUnderUserMyAccountModal";
    LegacyEventsEnum["ShowUpdateProfileDialog"] = "popUnderUpdateProfileModal";
    // user account types messages
    LegacyEventsEnum["UserIsActiveEnterprise"] = "sendUserIsActiveEnterpriseMessage";
    LegacyEventsEnum["UserIsActiveProfessional"] = "sendUserIsActiveProfessionalMessage";
    LegacyEventsEnum["UserIsNotEnterprise"] = "sendUserIsNotEnterpriseMessage";
    LegacyEventsEnum["UserIsNotProfessional"] = "sendUserIsNotProfessionalMessage";
    LegacyEventsEnum["UserIsPastDueEnterprise"] = "sendUserIsPastDueEnterpriseMessage";
    LegacyEventsEnum["UserIsPastDueProfessional"] = "sendUserIsPastDueProfessionalMessage";
    // upgrade dialogs
    LegacyEventsEnum["ShowEnrollDialog"] = "popUnderEnrollmentModal";
    // upgrade options
    LegacyEventsEnum["ShowSettingsDialog"] = "popUnderSettingsModal";
    LegacyEventsEnum["ShowUpdateSubscriptionDialog"] = "popUnderUpdateSubscriptionModal";
    LegacyEventsEnum["ShowUpgradeDialog"] = "popUnderUpgradeHumanModal";
    // checkout dialog
    LegacyEventsEnum["ShowCheckoutDialog"] = "popUnderSubscriptionModal";
    LegacyEventsEnum["ShowEnterpriseDomainDialog"] = "popUnderEnterpriseDomainModal";
    // dialog messages
    LegacyEventsEnum["CloseDialogBoxMessage"] = "sendUserClosesModalDialogBoxMessage";
    // developer app selection
    LegacyEventsEnum["DeveloperAppSelected"] = "sendDeveloperAppSelected";
    // misc
    LegacyEventsEnum["ShowSelectDevAppDialog"] = "popUnderSelectDevAppModal";
    LegacyEventsEnum["ShowSocialShareDialog"] = "popUnderSocialShareModal";
    LegacyEventsEnum["ShowUserPremiumAlertDialog"] = "popUnderUserPremiumAlertModal";
    LegacyEventsEnum["ShowUserTourAlertDialog"] = "popUnderUserTourAlertModal";
    LegacyEventsEnum["ShowUserGenderToggleDialog"] = "popUnderUserGenderToggleAlert";
    LegacyEventsEnum["ShowUserTestAbortAlert"] = "popUnderUserTestAbortAlert";
})(LegacyEventsEnum || (LegacyEventsEnum = {}));
var LegacyMessage = /** @class */ (function () {
    function LegacyMessage() {
    }
    return LegacyMessage;
}());
export { LegacyMessage };
var LegacyMessageService = /** @class */ (function () {
    function LegacyMessageService() {
        this.messageSubject = new Subject();
        this.initMessageListner();
    }
    /**
     * Observe a legacy event
     */
    LegacyMessageService.prototype.onEvent = function (event) {
        return this.messageSubject.asObservable()
            .pipe(filter(function (e) { return e.eventName === event; }));
    };
    LegacyMessageService.prototype.initMessageListner = function () {
        var _this = this;
        var legacyTypeName = 'human.web.legacy';
        fromEvent(window, 'message')
            .pipe(
        // validate: filter out legacy messages
        filter(function (e) {
            var origin = e.origin, data = e.data;
            return origin === window.location.origin
                && data
                && typeof (data) === 'string'
                && ("" + data).indexOf(legacyTypeName) !== -1;
        }), 
        // extract data
        map(function (e) { return JSON.parse(e.data); }), 
        // validate legacy message
        filter(function (e) { return e && e.type === legacyTypeName; }))
            .subscribe(function (message) {
            _this.messageSubject.next(message);
        });
    };
    LegacyMessageService.ngInjectableDef = i0.defineInjectable({ factory: function LegacyMessageService_Factory() { return new LegacyMessageService(); }, token: LegacyMessageService, providedIn: "root" });
    return LegacyMessageService;
}());
export { LegacyMessageService };
